module.exports = __webpack_public_path__ + "img/analytics.0431a338.png";